<template>
    <div class="mead-app-sidebar-mobile-menu f fv" :class="[uiShowSubMenu ? 'el--sub-menu' : '']">
        <div class="mead-app-sidebar-mobile-slide-area f fh fg">
            <!-- Left pane: top level items -->
            <nav class="mead-app-sidebar-mobile-pane sp-m"
                :class="[uiShowSubMenu ? 'el--hidden' : '']"
                :aria-label="uiNavigationName">
                <AppSidebarItem v-for="item in items"
                    :key="item.uid"
                    :item="item"
                    :showIcon="true"
                    :expandable="false"
                    :primary="true"
                    @select="onSelectTopItem"
                    @upsell="$emit('upsell', $event)" />
            </nav>
            <!-- Right pane: children of the open section -->
            <div class="mead-app-sidebar-mobile-pane sp-m"
                :class="[uiShowSubMenu ? '' : 'el--hidden']">
                <template v-if="paneItem">
                    <div class="f fa-c sm-b-s">
                        <mead-button-icon icon="chevron-left"
                            class="el--transparent sm-r-s"
                            :title="'mead.back'"
                            qa="app-sidebar-mobile-back"
                            @click="pane_choice = 'left'" />
                        <mead-icon v-if="paneItem.icon" :name="paneItem.icon" uiSize="l" class="sm-r-s" />
                        <div class="te-fat-section">{{ uiPaneTitle }}</div>
                    </div>
                    <nav :aria-label="uiPaneTitle">
                        <AppSidebarItem v-for="child in paneItem.children"
                            :key="child.uid"
                            :item="child"
                            @select="onSelectChild"
                            @upsell="$emit('upsell', $event)" />
                    </nav>
                </template>
            </div>
        </div>
        <div v-if="$scopedSlots.footer" class="mead-app-sidebar-mobile-footer sp-m">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
import AppSidebarItem from './AppSidebarItem.vue';

export default {
    name: 'mead-app-sidebar-mobile-menu',
    components: {AppSidebarItem},
    props: {
        /**
         * Top level `MeadCommon.AppSidebarItem`s, listed in the left pane. Everything is derived from this prop so the
         * menu follows changes to it while open.
         */
        items: {type: Array, default: () => []},
        /**
         * The section currently selected in the sidebar. When it has children the menu opens on them.
         */
        selectedItem: {type: Object, default: null},
    },
    data: function () {
        return {
            // uid of the top level item the user opened in this menu, null until they pick one
            pane_uid: null,
            // 'left' once the user goes back to the top level list, 'right' after opening a section
            pane_choice: null,
        };
    },
    methods: {
        onSelectTopItem: function (item) {
            if (item.hasChildren) {
                this.pane_uid = item.uid;
                this.pane_choice = 'right';
            } else {
                this.$emit('select', item, item);
            }
        },
        onSelectChild: function (child) {
            this.$emit('select', child, this.paneItem);
        },
    },
    computed: {
        paneItem: function () {
            const uid = this.pane_uid !== null ? this.pane_uid : this.selectedItem?.uid;
            const item = this.items.find(i => i.uid === uid);
            return item && !item.upsell && item.hasChildren ? item : null;
        },
        uiShowSubMenu: function () {
            return this.paneItem !== null && this.pane_choice !== 'left';
        },
        uiPaneTitle: function () {
            return this.paneItem ? MeadCommon.I18N.go(this.paneItem.label) : '';
        },
        uiNavigationName: function () {
            return MeadCommon.I18N.go('mead.main_navigation');
        },
    },
};
</script>

<style lang="scss" scoped>
.mead-app-sidebar-mobile-menu {
    //  clip rather than hidden, so focusing something in the other pane can't scroll it into view
    overflow: hidden;
    overflow: clip;
    background-color: var(--c-sidebar-rail-bg);
    transition: background-color .2s ease;

    &.el--sub-menu {
        background-color: var(--c-sidebar-panel-bg);
    }

    .mead-app-sidebar-mobile-slide-area {
        width: 200%;
        min-height: 0;
        transition: transform .2s ease;
    }

    &.el--sub-menu .mead-app-sidebar-mobile-slide-area {
        transform: translateX(-50%);
    }

    .mead-app-sidebar-mobile-pane {
        width: 50%;
        flex-shrink: 0;
        box-sizing: border-box;
        overflow-y: auto;

        //  Hidden once it has slid out of view, which also takes it out of the tab order
        &.el--hidden {
            visibility: hidden;
            transition: visibility 0s .2s;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        &,
        .mead-app-sidebar-mobile-slide-area {
            transition: none;
        }
    }
}
</style>
